<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part" id="p01"><a id="page_1"></a><span class="small">PART ONE</span><br/>THE IMPRINT A BODY MAKES</h1>
<p class="center"><img alt="" src="OEBPS/images/9780312374648_L02.jpg"/></p>
<div class="block">
<p class="center"><em>Even in the valley of the shadow of death, two and two do not make six.</em></p>
<p class="right">—<span class="small">LEO TOLSTOY</span><a id="page_2"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312374648_epub_p01_r1.vue?0b55eed0